import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

// PublicRoute Component
export const PublicRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search);
  const getIccid = searchParams.get('iccid');
  const getPin = searchParams.get("pin");
  const redirectPath = searchParams.get('redirect');

  useEffect(() => {
    if(location.hash?.includes('#contact') && isAuthenticated){
      navigate('/dashboard#contact')
    } else if (getIccid) {
      navigate( isAuthenticated ? '/dashboard' : '/signup', {state: {iccid:getIccid,pin:getPin}})
    }else if (redirectPath && isAuthenticated) {
      navigate(`/${redirectPath}`, { replace: true });
    }
  }, [dispatch, getIccid, getPin, navigate,redirectPath, isAuthenticated,location.hash])

  return isAuthenticated ? <Navigate to="/dashboard" /> : <Outlet />;
};

// PrivateRoute Component
export const PrivateRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  const isReceiptsPage = location.pathname === "/receipts";

  if (!isAuthenticated) {
    return isReceiptsPage ? (
      <Navigate to={`/?redirect=receipts`} replace />
    ) : (
      <Navigate to="/" replace />
    );
  }

  return <Outlet />;

};
